import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import CongratulationsImage from 'public/images/congratulations.svg';
import useCurrentUser from 'hooks/useCurrentUser';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/Congratulations.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    backgroundColor: '#f5f0ff',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      width: '60%',
      height: 'auto',
      borderRadius: 10,
    },

    [theme.breakpoints.up('md')]: {
      width: '50%',
    },

    [theme.breakpoints.up('lg')]: {
      width: '30%',
    },
  },

  paperFullWidth: {
    [theme.breakpoints.up('md')]: {
      margin: '0 auto',
      borderRadius: 10,
    },
  },
}));

const noBottomMargin = { marginBottom: 0 };

const SuccessPaymentDialog = () => {
  const open = useModalOpen('Wish Payment Success');
  const classes = useStyles();
  const router = useRouter();
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();

  const handleClose = () => {
    dispatch(closeModal('Wish Payment Success'));

    const redirectUrl = currentUser?.full_management_agency ? '/agency-offers' : '/dashboard';
    router.push(redirectUrl);
  };

  const fullWidth = { width: '100%' };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullWidth}
      desktopDirection="up"
      direction="up"
      noCloseIcon
    >
      <div className={styles.congratulations} style={{ minHeight: 'auto' }}>
        <div className={styles.title}>
          <CongratulationsImage />

          <h2 style={noBottomMargin}>Order has been processed successfully!</h2>

          <p style={{ margin: '30px 0' }}>
            Thank you for your purchase. The influencer will be notified shortly.
          </p>
        </div>

        <div className={styles.buttons}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            style={fullWidth}
            fullWidth
          >
            Ok
          </Button>
        </div>
      </div>
    </TransitionDialog>
  );
};

export default SuccessPaymentDialog;
